import { render, staticRenderFns } from "./GsCalendar.vue?vue&type=template&id=0f544984&scoped=true"
import script from "./GsCalendar.vue?vue&type=script&lang=js"
export * from "./GsCalendar.vue?vue&type=script&lang=js"
import style0 from "./GsCalendar.vue?vue&type=style&index=0&id=0f544984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f544984",
  null
  
)

export default component.exports